import { SagaIterator } from "redux-saga";
import { call, put } from "redux-saga/effects";
import { HttpResponseTypeEnum } from "../core/enumerations/ServerRequestStatusEnum";
import { notificationsRedux } from "../redux/notification-redux/NotificationsRedux";

export function* getAllUserNotificationsSaga(
    api: any,
    action: any
): SagaIterator {
    try {
        const response = yield call(
            api.getAllUserNotifications,
            action.payload
        );
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(
                notificationsRedux.actions.getAllUserNotificationsSuccess(response.data)
            );
        } else {
            yield put(
                notificationsRedux.actions.getAllUserNotificationsFailure(response.data)
            );
        }
    } catch (error) {
        yield put(notificationsRedux.actions.getAllUserNotificationsFailure(error));
    }
}

export function* updateNotificationSaga(
    api: any,
    action: any
): SagaIterator {
    try {
        const response = yield call(api.updateNotification, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(
                notificationsRedux.actions.updateNotificationSuccess(response.data)
            );
        } else {
            yield put(
                notificationsRedux.actions.updateNotificationFailure(response.data)
            );
        }
    } catch (error) {
        yield put(notificationsRedux.actions.updateNotificationFailure(error));
    }
}